import { ReactNode } from "react";
import CloseIcon from "../assets/li_x.svg";
import { useTranslations } from '../hooks/useTranslations';
import { translationKeys } from '../translations/translationKeys';

type HelpPanelProps = {
  onClose: () => void;
  children?: ReactNode;
};

const HelpPanel = ({
  onClose,
  children,
}: HelpPanelProps) => {
  const { translate } = useTranslations();
  return (
    <section className="bg-surface-secondary text-content-primary flex h-full flex-col rounded-t-3xl md:rounded-none">
      <header className="flex items-center justify-between border-b border-surface-separator px-6 py-6">
        <h2 className="text-xl font-normal leading-7">{translate(translationKeys.HERE_FOR_YOU)}</h2>
        <button
          type="button"
          aria-label={translate(translationKeys.SAVE_CLOSE_PANEL)}
          onClick={onClose}
          className="inline-flex cursor-pointer items-center justify-center rounded-full text-content-primary transition-colors hover:text-interactive-content-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-interactive-outline-focus"
        >
          <img src={CloseIcon} alt={translate(translationKeys.CLOSE)} className="h-6 w-6" />
        </button>
      </header>
      {children ? (
        <div className="flex-1 overflow-y-auto px-6 py-6">
          <div className="flex min-h-full flex-col justify-center gap-6">
            {children}
          </div>
        </div>
      ) : null}
      <footer className="mt-auto shrink-0 border-t border-surface-separator px-6 py-6 text-center">
        <p className="text-xs font-normal leading-4 text-content-muted">
          {translate(translationKeys.SUPPORT_TEAM_AVAILABILITY_TEXT)}
        </p>
      </footer>
    </section>
  );
};

export default HelpPanel;
